module.exports = __webpack_public_path__ + "static/media/icon-header-preview.16ab059f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/HeaderNoLogout/assets/icon-header-preview.svg
// module id = 1848
// module chunks = 193